import type {
  Customer,
  CustomerListResponse,
  CustomerParams,
} from 'types/customer'

import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'

export async function getCustomers(
  { page = 1, pageSize = 10, search, ordering }: CustomerParams = {},
  requestParams: { signal?: AbortSignal } = {}
): Promise<CustomerListResponse> {
  return await makeGetRequest(
    ApiBase +
      `/customers?page=${page}&page_size=${pageSize}` +
      (search ? `&search=${search}` : '') +
      (ordering ? `&ordering=${ordering}` : ''),
    requestParams
  )
}

export async function getCustomer(id: string): Promise<Customer> {
  return await makeGetRequest(ApiBase + `/customers/${id}`)
}
